// import React from "react";
import { FaSearch, FaMapMarkerAlt, FaBriefcase } from "react-icons/fa"; // Import icons
import Input from "../Input";
import Button from "../Button";

interface SearchFormProps {
  onSearch: (e: React.FormEvent) => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ onSearch }) => {
  return (
    <form
      onSubmit={onSearch}
      className="flex items-center space-x-4 bg-gray-100 p-2 rounded-lg"
    >
      {/* Title Input */}
      <div className="flex items-center border border-gray-300 rounded-lg px-3  bg-white">
        <FaBriefcase className="text-gray-400 mr-2" />
        <Input
          type="text"
          placeholder="Service Title"
          className="border-none focus:ring-0 p-0 text-sm"
        />
      </div>

      {/* Location Input */}
      <div className="flex items-center border border-gray-300 rounded-lg px-3  bg-white">
        <FaMapMarkerAlt className="text-gray-400 mr-2" />
        <Input
          type="text"
          placeholder="Location"
          className="border-none focus:ring-0 p-0 text-sm"
        />
      </div>

      {/* Search Button */}
      <Button
        type="submit"
        className="bg-primary text-white font-semibold px-4 py-2 rounded-lg hover:bg-white hover:text-primary hover:border-[#F8735F] border transition"
      >
        <FaSearch className="mr-2" />
      </Button>
    </form>
  );
};

export default SearchForm;
